export const deDE = {
  app: {
    categories: {
      convectors: 'Konvektoren',
      decorative: 'Designheizkörper',
      electric: 'E-Heizkörper',
      panels: 'Kompaktheizkörper',
      towel: 'Badheizkörper',
    },
    categoryLabel: 'Kategorie',
    categoryPlaceholder: 'Kategorie auswählen',
    errorCategories: 'Kategorien konnten nicht geladen werden.',
    errorPanels: 'Heizkörper konnten nicht geladen werden.',
    loadingCategories: 'Kategorien werden geladen...',
    loadingPanels: 'Heizkörper werden geladen...',
    panelLabel: 'Heizkörper',
    panelPlaceholder: 'Heizkörper auswählen',
    titles: {
      convectors: 'Konvektor-Kalkulator',
      decorative: 'Designheizkörper-Kalkulator',
      electric: 'E-Heizkörper-Kalkulator',
      panels: 'Kompaktheizkörper-Kalkulator',
      towel: 'Badheizkörper-Kalkulator',
    },
  },
  calc: {
    actionButton: 'Berechnete Artikel anzeigen',
    boost: 'Boost-Modus',
    calculateRequiredButton: 'Benötigte Leistung ermitteln',
    calculating: 'Wird berechnet...',
    comfort: 'Komfortmodus',
    downloadLabel: 'Daten herunterladen ({count})',
    emptyResults: 'Noch keine Ergebnisse.',
    errorMatch: 'Die Ergebnisse konnten nicht ermittelt werden.',
    errorTypes: 'Heizkörpertypen konnten nicht geladen werden.',
    flowTemp: 'Vorlauftemperatur C°',
    height: 'Höhe',
    length: 'Länge',
    loadingTypes: 'Typen werden geladen...',
    modeLabel: 'Modus',
    modes: {
      cooling: 'Kühlen',
      heating: 'Heizen',
    },
    radiatorType: 'Heizkörpertyp',
    requiredWatts: 'Benötigte Wattleistung',
    resultsMessage: '{count} Artikel für die ausgewählten Optionen verfügbar.',
    returnTemp: 'Rücklauftemperatur C°',
    roomTemp: 'Raumtemperatur C°',
    selectAllLabel: 'Alle Artikel auswählen',
    selectItemLabel: 'Artikel zum Herunterladen auswählen',
    selectPanel: 'Wählen Sie einen Heizkörper zur Berechnung.',
    standby: 'Standby-Modus',
    tableHeaders: {
      calculatedWattage: 'Leistung',
      co2Equivalent: 'CO2-Äquivalent pro kg oder Material',
      depth: 'Tiefe [mm]',
      description: 'Artikelbeschreibung',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Höhe [mm]',
      itemId: 'Artikelnummer',
      length: 'Länge [mm]',
      waterContent: 'Wasserinhalt',
      weight: 'Gewicht',
    },
    title: 'Berechnungen',
    tolerance: 'Toleranz',
    typeCooling: 'Kühlen',
    typeGroupLabel: 'Typ',
    typeHeating: 'Heizen',
  },
  deVariantRadiator: {
    depth: 'Bautiefe',
    description:
      'Berechnung der Wärmeleistung für Bestandsheizkörper (Stahlrohre, Stahlrippen, Gussradiatoren).',
    elements: 'Anzahl Glieder',
    height: 'Bauhöhe',
    resultLabelTemplate: 'Wärmeleistung bei Systemtemperatur {temp}',
    select: 'Auswählen',
    temperature: 'Systemtemperatur',
    type: 'Bauart',
  },
  existingRadiator: {
    description:
      'Dieser Kalkulator dient nur zur überschlägigen Kalkulation und zur Orientierung. Bitte lassen Sie sich vor Einbau eine genaue Berechnung von Ihrem Fachbetrieb erstellen!',
    height: 'Heizkörperhöhe',
    length: 'Heizkörperlänge',
    resultLabelTemplate: 'Wärmeleistungsbedarf, berechnet bei Systemtemperatur {temp}',
    select: 'Auswählen',
    temperature: 'Systemtemperatur',
    type: 'Heizkörpertyp',
  },
  matrixCalc: {
    axisHeight: 'Höhe (mm)',
    axisLength: 'Länge (mm)',
    axisType: 'Typ',
    calculateButton: 'Calculate',
    displayLabel: 'Anzeige',
    exportExcel: 'Als Excel exportieren',
    exportPdf: 'Als PDF exportieren',
    print: 'Drucken',
    hideOutOfRange: 'Artikel außerhalb des Bereichs ausblenden',
    showAll: 'Alle anzeigen',
    loading: 'Loading...',
    lockHeight: 'Höhe',
    lockLabel: 'Dimension fixieren',
    lockLength: 'Länge',
    lockType: 'Typ',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Berechnen',
    clearButton: 'Alles löschen',
    fields: {
      ceilingHeight: 'Deckenhöhe',
      doorInsulation: 'Türdämmung',
      floorInsulation: 'Bodendämmung',
      glazingArea: 'Verglasungsfläche',
      glazingMode: 'Verglasungsfläche',
      glazingQuality: 'Verglasungsqualität',
      length: 'Länge',
      outerWalls: 'Außenwände',
      projectedDesignTemp: 'Auslegungs-Außentemperatur am Gebäudestandort',
      roofInsulation: 'Dachdämmung',
      roomArea: 'Raumfläche',
      roomFloor: 'Geschoss',
      roomInsulation: 'Dämmstandard',
      roomPreset: 'Raumvorgabe',
      roomTemperature: 'Raumtemperatur',
      roomType: 'Raumart',
      uncertaintyFactor: 'Sicherheitsfaktor',
      ventilation: 'Luftwechsel',
      wallInsulation: 'Wanddämmung',
      width: 'Breite',
      windConditions: 'Windbedingungen',
      windowInsulation: 'Fensterdämmung',
    },
    intro:
      'Ermitteln Sie die überschlägige Heizlast im Raum, um den richtigen Heizkörper aus dem Purmo Heizkörperprogramm auszuwählen.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Mehr als 20%',
        low: 'Weniger als 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Über 20%',
        below_10: 'Unter 10%',
        from_10_to_20: 'Von 10% bis 20%',
        no_windows: 'Ohne Fenster',
      },
      insulationValue: {
        good: 'Gut',
        medium: 'Mittel',
        poor: 'Schlecht',
        very_good: 'Sehr gut',
      },
      qualityValue: {
        modern_excellent: 'Neu (Wärmeschutzglas)',
        modern_good: 'Modern  (Dreifachverglasung)',
        old_poor: 'Alt (Einscheibenverglasung)',
        traditional_medium: 'Alt (Doppelverglasung)',
      },
      roomValue: {
        bathroom_24: 'Bad/Dusche (24 C°)',
        bedroom_20: 'Wohnräume (20 C°)',
        garage_12: 'Garage/Keller (10 C°)',
        livingroom_22: 'Wohnräume Komfort (22°C)',
        storage_16: 'Abstellraum/Flur (15 C°)',
        extra_1: 'Nebenraum (18°C)',
      },
      select: 'Auswählen',
      storeyValue: {
        ground_multi: 'Erdgeschoss (Unterkellert)',
        ground_single: 'Erdgeschoss (nicht unterkellert)',
        interim: 'Zwischengeschoss',
        top_multi: 'Dachgeschoß',
      },
      temp: {
        climate_zone_1: '-10°C',
        climate_zone_2: '-12°C',
        climate_zone_3: '-14°C',
        climate_zone_4: '-16°C',
        climate_zone_5: '-18°C',
        climate_zone_6: '-20°C',
      },
      windInfluence: {
        normal: 'Normal',
        strong: 'Stark',
        weak: 'Schwach',
      },
    },
    roomPresets: {
      bathroom: 'Badezimmer',
      bedroom: 'Schlafzimmer',
      garage: 'Garage',
      kitchen: 'Küche',
      living: 'Wohnzimmer',
      storage: 'Abstellraum',
    },
    sections: {
      dimensions: 'Raummaße',
      insulation: 'Dämmung',
      placement: 'Gebäudedaten',
      result: 'Ergebnis',
      temps: 'Temperaturen',
      ventilation: 'Lüftung',
    },
    title: 'Heizlast Kalkulator',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Übernehmen',
  },
  slider: {
    from: 'Von',
    to: 'Bis',
    value: 'Wert',
  },
}
